import axios from 'axios';
import { API_HOST } from '../constants/constants';
export const getResult = async (query, personality, page, rowsPerPage, type, locale, filterExplicit, timeRange) => {
  if(!query){
    return false
  }
  const { token, userID } = ''//useCurrentUser();
  try {
    const { data } = await axios.get(`${API_HOST}/test_ai?type=personality&prompt=${query}&personality=${personality.name}`,{
      headers: {
        'Authorization': 'Bearer '+token,
        'x-asktheai-user-id': userID
      }
    });
    return data;
  } catch (error) {
    console.error(error);
  }
};
